module.exports = __webpack_public_path__ + "static/img/公司简介4.2f4444c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/公司简介4.png
// module id = yI6Q
// module chunks = 1